import {createAction} from 'redux-actions';

import * as actionTypes from 'web-app/react/constants/action-types';

export const loadFiles = createAction(actionTypes.FILE_UPLOAD_LOAD_FILES, (formName, files) => ({formName, files}));

export const clearFiles = createAction(actionTypes.FILE_UPLOAD_CLEAR_FILES, formName => ({formName}));

export const addUploadedFile = createAction(actionTypes.FILE_UPLOAD_ADD_UPLOADED_FILE, (formName, file) => ({
    formName,
    file,
}));

/**
 * `createAction` @ redux-actions has no overload for 5 arguments, so I'm
 * just quick-fixing it by casting it to any 🤷‍♂️
 */
export const fileUploadSuccess = (createAction as any)(
    actionTypes.FILE_UPLOAD_FILE_UPLOAD_SUCCESS,
    (formName, file, uploadedFile, config, uncompressedFile, compressionConfig) => ({
        formName,
        file,
        uploadedFile,
        config,
        uncompressedFile,
        compressionConfig,
    }),
);
export const fileUploadFailed = createAction(
    actionTypes.FILE_UPLOAD_FILE_UPLOAD_FAILED,
    (formName, file, uncompressedFile, compressionConfig) => ({
        formName,
        file,
        uncompressedFile,
        compressionConfig,
    }),
);
export const fileUploadProgress = createAction(
    actionTypes.FILE_UPLOAD_FILE_UPLOAD_PROGRESS,
    (formName, file, percentLoaded) => ({formName, file, percentLoaded}),
);

export const filePersistFailed = createAction(actionTypes.FILE_UPLOAD_FILE_PERSIST_FAILED, (formName, file) => ({
    formName,
    file,
}));

export const readFileSuccess = createAction(actionTypes.FILE_UPLOAD_READ_FILE_SUCCESS, (formName, file, data) => ({
    formName,
    file,
    data,
}));
export const extendSession = createAction(actionTypes.FILE_UPLOAD_EXTEND_SESSION, () => ({}));
